import request from "./request";

// 权益列表

export function interestsList(params) {
  return request({
    method: "POST",
    url: "/Member/interestsList",
    data: params,
  });
}

// 开关操作

export function openOperate(params) {
  return request({
    method: "POST",
    url: "/Member/openOperate",
    data: params,
  });
}

// 权益添加、编辑-获取商家列表

export function interestsStoreList(params) {
  return request({
    method: "POST",
    url: "/Member/interestsStoreList",
    data: params,
  });
}

// 获取已关联商家列表

export function interestsStore(params) {
  return request({
    method: "POST",
    url: "/Member/interestsStore",
    data: params,
  });
}

// 权益关联门店商处理

export function interestsStoreHandle(params) {
  return request({
    method: "POST",
    url: "/Member/interestsStoreHandle",
    data: params,
  });
}

// 权益添加、编辑

export function interestsSet(params) {
  return request({
    method: "POST",
    url: "/Member/interestsSet",
    data: params,
  });
}

// 权益详情

export function interestsInfo(params) {
  return request({
    method: "POST",
    url: "/Member/interestsInfo",
    data: params,
  });
}

// 门店商列表

export function storeList(params) {
  return request({
    method: "POST",
    url: "/Member/storeList",
    data: params,
  });
}

// 门店列表

export function shopList(params) {
  return request({
    method: "POST",
    url: "/Member/shopList",
    data: params,
  });
}

// 门店商下拉门店

export function shopDrop(params) {
  return request({
    method: "POST",
    url: "/Member/shopDrop",
    data: params,
  });
}

// 门店商续费日志

export function storeRenewLog(params) {
  return request({
    method: "POST",
    url: "/Member/storeRenewLog",
    data: params,
  });
}

// 门店商扩店日志

export function storeExtendLog(params) {
  return request({
    method: "POST",
    url: "/Member/storeExtendLog",
    data: params,
  });
}
// 员工列表

export function staffList(params) {
  return request({
    method: "POST",
    url: "/Member/staffList",
    data: params,
  });
}

// 员工列表操作

export function staffOperate(params) {
  return request({
    method: "POST",
    url: "/Member/staffOperate",
    data: params,
  });
}

// 表格下载-员工列表

export function tableDownload(params) {
  return request({
    method: "POST",
    url: "/Member/tableDownload",
    data: params,
    responseType: "blob",
  });
}

// 门店商分配账号

export function storeAccount(params) {
  return request({
    method: "POST",
    url: "/Member/storeAccount",
    data: params,
  });
}

// 门店商扩店 5-8

export function storeExtend(params) {
  return request({
    method: "POST",
    url: "/Member/storeExtend",
    data: params,
  });
}
// 门店商编辑，添加

export function storeSet(params) {
  return request({
    method: "POST",
    url: "/Member/storeSet",
    data: params,
  });
}

// 地区-省，市，区

export function getRegion(params) {
  return request({
    method: "POST",
    url: "/index/getRegion2",
    data: params,
  });
}

//图片上传
export function imageUp(params) {
  return request({
    method: "POST",
    url: "/Uploadify/imageUp",
    data: params,
  });
}

// 门店商续费

export function storeRenew(params) {
  return request({
    method: "POST",
    url: "/Member/storeRenew",
    data: params,
  });
}

// 用户会员卡列表

export function userCard(params) {
  return request({
    method: "POST",
    url: "/Member/userCard",
    data: params,
  });
}

// 下拉门店商

export function storeDrop(params) {
  return request({
    method: "POST",
    url: "/Member/storeDrop",
    data: params,
  });
}

// 商家门店二级联动列表
export function storeShopDrop(params) {
  return request({
    method: "POST",
    url: "/Member/storeShopDrop",
    data: params,
  });
}

// 表格下载-会员卡

export function userDownload(params) {
  return request({
    method: "POST",
    url: "/Member/tableDownload2",
    data: params,
    responseType: "blob",
  });
}

// 会员卡详情

export function userCardInfo(params) {
  return request({
    method: "POST",
    url: "/Member/userCardInfo",
    data: params,
  });
}

// Edit customer info on member card detail.

export function userCardEdit(params) {
  return request({
    method: "POST",
    url: "/Member/userCardEdit",
    data: params,
  });
}

// 核销记录列表

export function writeList(params) {
  return request({
    method: "POST",
    url: "/Member/writeList",
    data: params,
  });
}

// 核销类型下拉

export function writeTypeDrop(params) {
  return request({
    method: "POST",
    url: "/Member/writeTypeDrop",
    data: params,
  });
}

// 表格下载-核销记录

export function writeListDownload(params) {
  return request({
    method: "POST",
    url: "/Member/tableDownload3",
    data: params,
    responseType: "blob",
  });
}

// 协议列表

export function agreement(params) {
  return request({
    method: "POST",
    url: "/Member/agreement",
    data: params,
  });
}

// 协议详情-修改

export function agreementEdit(params) {
  return request({
    method: "POST",
    url: "/Member/agreementEdit",
    data: params,
  });
}

// 协议详情

export function agreementInfo(params) {
  return request({
    method: "POST",
    url: "/Member/agreementInfo",
    data: params,
  });
}

// 20250804核销方式配置
export function storeMode(params) {
  return request({
    method: "POST",
    url: "/Member/storeMode",
    data: params,
  });
}
